import api from "@/api/v1-jwt/config/api";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import notificationQueryKeys from "./query-keys";
import { NotificationInfo, AddNotificationPayload } from "./types";

interface AddNotificationParams {
  userId: string;
  notificationSubject: string;
  payload: AddNotificationPayload;
}

const addNotification = async ({
  userId,
  notificationSubject,
  payload,
}: AddNotificationParams): Promise<NotificationInfo> => {
  const url = `/platform/notifications/${userId}/info`;
  const requestBody = {
    notification_subject: notificationSubject.toUpperCase(),
    notification_info: {
      notification_info: [payload],
    },
  };
  const { data } = await api.post(url, requestBody);
  return data.data;
};

export const useAddNotification = (
  options?: Omit<
    UseMutationOptions<NotificationInfo, Error, AddNotificationParams>,
    "mutationFn"
  >
) => {
  const queryClient = useQueryClient();

  return useMutation<NotificationInfo, Error, AddNotificationParams>({
    ...options,
    mutationFn: addNotification,
    onSuccess: (...d) => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.all,
      });
      if (options?.onSuccess) {
        options?.onSuccess(...d);
      }
    },
  });
};
